var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.33203 0 0 3.33203 0 7.5C0 8.94141 0.429687 10.0547 1.17578 11.1836L6.71094 19.582C6.87891 19.8359 7.16797 20 7.5 20C7.83203 20 8.125 19.832 8.28906 19.582L13.8242 11.1836C14.5703 10.0547 15 8.94141 15 7.5C15 3.33203 11.668 0 7.5 0ZM7.5 11.6641C5.19922 11.6641 3.33203 9.79688 3.33203 7.49219C3.33203 5.1875 5.19922 3.32031 7.5 3.32031C9.80078 3.32031 11.668 5.1875 11.668 7.49219C11.668 9.79688 9.80078 11.6641 7.5 11.6641ZM7.5 5C6.11719 5 5 6.11719 5 7.5C5 8.88281 6.11719 10 7.5 10C8.88281 10 10 8.88281 10 7.5C10 6.11719 8.88281 5 7.5 5Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.27fa76c3.svg";
export { ForwardRef as ReactComponent };